import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { theme } from '../../../styles/theme';

type IDropzoneAreaSize = 'small' | 'large';

interface IProps {
  children: ReactNode;
  size: IDropzoneAreaSize;
}

const Container = styled.div<{ $size: IDropzoneAreaSize }>`
  width: ${({ $size }) => ($size === 'small' ? '128px' : '100%')};
  height: ${({ $size }) => ($size === 'small' ? '26px' : '32px')};
  font-size: ${({ $size }) => ($size === 'small' ? '10px' : '12px')};
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${theme.colors.secondary900};
`;

const DropzoneArea = ({ children, size }: IProps) => (
  <Container $size={size}>{children}</Container>
);

export default DropzoneArea;
